export const getMarkdownStyle = (isDark: boolean) => ({
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  wordBreak: "break-word" as const,
  "& ul": { margin: 0, marginBottom: "1em" },
  "& .markdown": {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    maxWidth: "100%",
    minWidth: 0,
  },
  "& .markdown:has(.csu-otg-table), & .markdown:has(.csu-matrix)": {
    overflowX: "hidden",
  },
  "& .markdown table": {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    tableLayout: "fixed" as const,
  },
  "& .markdown th, & .markdown td": {
    wordBreak: "normal" as const,
    overflowWrap: "break-word" as const,
    fontSize: { xs: "10px", sm: "11px", md: "16px" },
    lineHeight: { xs: 1.2, sm: 1.25, md: 1.35 },
    padding: { xs: "4px 6px", sm: "6px 8px", md: "8px 10px" },
  },
  "& .markdown th:first-of-type, & .markdown td:first-of-type": {
    minWidth: "96px",
  },
  "& .markdown .csu-otg-embed": {
    maxWidth: "100%",
    minWidth: 0,
    padding: { xs: "8px", sm: "16px" },
    ...(isDark && {
      color: "#E8EEF7",
      background: "#1A1F2E",
      borderColor: "#3A4558",
    }),
  },
  "& .markdown .csu-otg-heading h2, & .markdown .csu-otg-heading p": {
    overflowWrap: "anywhere" as const,
  },
  "& .markdown .csu-otg-scroll": {
    overflowX: "hidden",
    maxWidth: "100%",
    minWidth: 0,
    ...(isDark && {
      borderColor: "#3A4558",
    }),
  },
  "& .markdown table.csu-otg-table": {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    tableLayout: "fixed",
    borderCollapse: "separate" as const,
    marginTop: 0,
  },
  "& .markdown .csu-otg-table th, & .markdown .csu-otg-table td": {
    fontSize: { xs: "8px", sm: "13px" },
    lineHeight: { xs: 1.15, sm: 1.35 },
    padding: { xs: "4px 3px", sm: "10px" },
    wordBreak: { xs: "break-word", sm: "normal" } as const,
    overflowWrap: "break-word" as const,
    whiteSpace: "normal" as const,
    hyphens: { xs: "auto", sm: "manual" },
    ...(isDark && {
      borderColor: "#3A4558",
      color: "#E8EEF7",
    }),
  },
  "& .markdown .csu-otg-table thead th": {
    fontSize: { xs: "6px", sm: "12px" },
    letterSpacing: { xs: 0, sm: "0.02em" },
    lineHeight: { xs: 1.05, sm: 1.35 },
    padding: { xs: "4px 2px", sm: "10px" },
    backgroundColor: isDark ? "#1A2740" : "#10325a",
    color: "#fff",
  },
  "& .markdown .csu-otg-table th:first-of-type, & .markdown .csu-otg-table td:first-of-type, & .markdown .csu-otg-table th.csu-otg-stage":
    {
      width: { xs: "28%", sm: "auto" },
      minWidth: 0,
    },
  "& .markdown .csu-otg-table tr:nth-of-type(even)": isDark
    ? { backgroundColor: "transparent" }
    : {},
  "& .markdown .csu-otg-stage": {
    display: "table-cell",
    textAlign: "left",
    verticalAlign: "middle",
    ...(isDark && {
      backgroundColor: "#222836",
      color: "#E8EEF7",
    }),
  },
  "& .markdown .csu-otg-stage-number": {
    float: "left",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: { xs: "4px", sm: "9px" },
    width: { xs: "16px", sm: "24px" },
    height: { xs: "16px", sm: "24px" },
    fontSize: { xs: "8px", sm: "13px" },
  },
  "& .markdown .csu-otg-stage > span:not(.csu-otg-stage-number)": {
    display: "block",
    overflow: "hidden",
    ...(isDark && {
      color: "#E8EEF7",
    }),
  },
  "& .markdown .csu-otg-stage b": {
    fontSize: { xs: "8px", sm: "13px" },
    ...(isDark && {
      color: "#F0F4FA",
    }),
  },
  "& .markdown .csu-otg-stage small": {
    display: "block",
    maxWidth: { xs: "100%", sm: "260px", md: "320px" },
    fontSize: { xs: "7px", sm: "11px", md: "13px" },
    lineHeight: { xs: 1.2, sm: 1.3, md: 1.35 },
    ...(isDark && {
      color: "#9AA8BC",
    }),
  },
  "& .markdown .csu-otg-cell strong": {
    fontSize: { xs: "10px", sm: "17px" },
    ...(isDark && {
      color: "#F0F4FA",
    }),
  },
  "& .markdown .csu-otg-cell span": {
    fontSize: { xs: "7px", sm: "11px" },
    ...(isDark && {
      color: "#A8B4C8",
    }),
  },
  "& .markdown .csu-otg-level-0": isDark
    ? { backgroundColor: "#2A3142" }
    : {},
  "& .markdown .csu-otg-level-1": isDark
    ? { backgroundColor: "#4A3035" }
    : {},
  "& .markdown .csu-otg-level-2": isDark
    ? { backgroundColor: "#3D3828" }
    : {},
  "& .markdown .csu-otg-level-3": isDark
    ? { backgroundColor: "#2A3D34" }
    : {},
  "& .markdown .csu-otg-heading h2": {
    fontSize: { xs: "14px", sm: "20px" },
    ...(isDark && {
      color: "#F0F4FA",
    }),
  },
  "& .markdown .csu-otg-heading p": {
    fontSize: { xs: "10px", sm: "13px" },
    ...(isDark && {
      color: "#9AA8BC",
    }),
  },
  "& .markdown .csu-otg-legend": {
    fontSize: { xs: "9px", sm: "12px" },
    gap: { xs: "6px", sm: "10px" },
    ...(isDark && {
      color: "#A8B4C8",
    }),
  },
  "& .markdown .csu-otg-legend strong": isDark
    ? { color: "#C5D0E0" }
    : {},
  "& .markdown .csu-otg-swatch": isDark
    ? { borderColor: "#3A4558" }
    : {},
  "& .markdown .csu-otg-note": {
    fontSize: { xs: "9px", sm: "12px" },
    ...(isDark && {
      color: "#9AA8BC",
    }),
  },
  // CSU Opportunity to Grow heatmap (.csu-matrix).
  "& .markdown .csu-matrix": {
    maxWidth: "100%",
    minWidth: 0,
    borderRadius: "8px",
    border: "1px solid #d6e0ea",
    overflow: "hidden",
    fontFamily: "Arial, Helvetica, sans-serif",
    lineHeight: 1.35,
    color: "#10233f !important",
    background: "#fff",
  },
  "& .markdown .csu-matrix__header": {
    padding: { xs: "10px 10px 8px", sm: "16px 18px 12px" },
  },
  "& .markdown .csu-matrix__title": {
    margin: 0,
    fontSize: { xs: "14px", sm: "20px" },
    lineHeight: 1.2,
    color: "#10233f !important",
  },
  "& .markdown .csu-matrix__note": {
    margin: "5px 0 0",
    fontSize: { xs: "10px", sm: "13px" },
    lineHeight: 1.45,
    color: "#52677f !important",
  },
  "& .markdown .csu-matrix__table-wrap": {
    overflowX: "hidden",
    maxWidth: "100%",
    minWidth: 0,
  },
  "& .markdown .csu-matrix table": {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    marginTop: 0,
    tableLayout: "fixed",
    borderCollapse: "separate",
    borderSpacing: 0,
    border: "none",
    fontSize: { xs: "8px", sm: "13px" },
  },
  "& .markdown .csu-matrix th, & .markdown .csu-matrix td": {
    border: "none",
    borderRight: "1px solid #d6e0ea",
    borderBottom: "1px solid #d6e0ea",
    padding: { xs: "4px 3px", sm: "10px" },
    textAlign: "center",
    verticalAlign: "middle",
    wordBreak: { xs: "break-word", sm: "normal" } as const,
    overflowWrap: "break-word" as const,
    whiteSpace: "normal" as const,
    hyphens: { xs: "auto", sm: "manual" },
    lineHeight: { xs: 1.15, sm: 1.35 },
    color: "#10233f !important",
    backgroundColor: "transparent",
  },
  "& .markdown .csu-matrix th:last-child, & .markdown .csu-matrix td:last-child":
    {
      borderRight: 0,
    },
  "& .markdown .csu-matrix tr:last-child th, & .markdown .csu-matrix tr:last-child td":
    {
      borderBottom: 0,
    },
  "& .markdown .csu-matrix thead th": {
    fontSize: { xs: "6px", sm: "12px" },
    letterSpacing: { xs: 0, sm: "0.02em" },
    lineHeight: { xs: 1.05, sm: 1.35 },
    padding: { xs: "4px 2px", sm: "10px" },
    textTransform: "uppercase",
    fontWeight: 700,
    backgroundColor: "#10325a !important",
    color: "#ffffff !important",
  },
  "& .markdown .csu-matrix thead th:first-of-type, & .markdown .csu-matrix tbody th":
    {
      width: { xs: "28%", sm: "auto" },
      minWidth: 0,
      textAlign: "left",
    },
  "& .markdown .csu-matrix tbody th": {
    backgroundColor: "#f7f9fc !important",
    color: "#10233f !important",
    fontWeight: 700,
  },
  "& .markdown .csu-matrix tbody th > span:first-of-type": {
    display: "block",
    overflow: "hidden",
    fontWeight: 700,
    fontSize: { xs: "8px", sm: "13px" },
    color: "#10233f !important",
  },
  ...Object.fromEntries(
    [1, 2, 3, 4, 5].map((n) => [
      `& .markdown .csu-matrix tbody tr:nth-of-type(${n}) th > span:first-of-type::before`,
      {
        content: `"${n}"`,
        float: "left",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: { xs: "4px", sm: "9px" },
        width: { xs: "16px", sm: "24px" },
        height: { xs: "16px", sm: "24px" },
        borderRadius: "50%",
        backgroundColor: "#176f70",
        color: "#fff",
        fontWeight: 700,
        fontSize: { xs: "8px", sm: "13px" },
        lineHeight: 1,
      },
    ]),
  ),
  "& .markdown .csu-matrix tbody th small": {
    display: "block",
    overflow: "hidden",
    maxWidth: { xs: "100%", sm: "260px", md: "320px" },
    marginTop: "3px",
    marginLeft: { xs: "20px", sm: "33px" },
    fontWeight: 400,
    fontSize: { xs: "7px", sm: "11px", md: "13px" },
    lineHeight: { xs: 1.2, sm: 1.3, md: 1.35 },
    color: "#52677f !important",
  },
  "& .markdown .csu-matrix td strong": {
    display: "block",
    fontSize: { xs: "10px", sm: "15px" },
    color: "#10233f !important",
  },
  "& .markdown .csu-matrix td span": {
    display: "block",
    marginTop: "3px",
    fontSize: "11px",
    color: "#39506a !important",
  },
  "& .markdown .csu-matrix td small": {
    display: "block",
    marginTop: "3px",
    marginLeft: 0,
    marginRight: 0,
    width: "auto",
    padding: 0,
    border: "none",
    borderRadius: 0,
    color: "#52677f !important",
    backgroundColor: "transparent !important",
    fontSize: { xs: "8px", sm: "11px" },
    fontWeight: 600,
    lineHeight: 1.3,
  },
  "& .markdown .csu-matrix tr:nth-of-type(even)": {
    backgroundColor: "transparent !important",
  },
  "& .markdown .csu-matrix .priority-0": {
    backgroundColor: "#f4f7fa !important",
  },
  "& .markdown .csu-matrix .priority-1": {
    backgroundColor: "#f8d9de !important",
  },
  "& .markdown .csu-matrix .priority-2": {
    backgroundColor: "#fff0c2 !important",
  },
  "& .markdown .csu-matrix .priority-3": {
    backgroundColor: "#e5f3ec !important",
  },
  "& .markdown .csu-matrix__legend": {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    alignItems: "center",
    padding: { xs: "10px 12px", sm: "12px 18px" },
    color: "#52677f !important",
    fontSize: { xs: "10px", sm: "12px" },
    lineHeight: 1.35,
  },
  "& .markdown .csu-matrix__legend strong": {
    display: "inline",
    color: "#10233f !important",
    fontWeight: 700,
    lineHeight: "inherit",
  },
  "& .markdown .csu-matrix__key": {
    display: "inline-flex",
    gap: "5px",
    alignItems: "center",
    color: "#52677f !important",
  },
  "& .markdown .csu-matrix__swatch": {
    display: "inline-block",
    width: "14px",
    height: "14px",
    border: "1px solid #b9c6d3",
    borderRadius: "3px",
    flexShrink: 0,
  },
  "& .markdown .csu-matrix__swatch--1": {
    backgroundColor: "#f8d9de !important",
  },
  "& .markdown .csu-matrix__swatch--2": {
    backgroundColor: "#fff0c2 !important",
  },
  "& .markdown .csu-matrix__swatch--3": {
    backgroundColor: "#e5f3ec !important",
  },
});
